import React from 'react';
import { Box, Typography, Paper, Checkbox } from '@mui/material';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import ColorPalette from '../../../../colorpalette/ColorPalette';
import CustomButton from '../../../../components/buttons/CustomButton';

const SelectedRecipientsTable = ({ 
  selectedRecipients, 
  recipients, 
  handleRecipientSelectionChange, 
  handleSelectAllRecipients 
}) => {
  return (
    <Paper
      elevation={0}
      sx={{
        height: '100%',
        padding: '20px',
        backgroundColor: ColorPalette.white,
        borderRadius: '12px',
        display: 'flex',
        flexDirection: 'column',
        border: `1px solid ${ColorPalette.border}`,
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.03)'
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
        <Typography variant="h6" sx={{ fontWeight: 600, color: ColorPalette.textDark }}>
          Contatos Selecionados ({selectedRecipients.length})
        </Typography>
        {selectedRecipients.length > 0 && (
          <CustomButton
            style="error"
            variant="outlined"
            label="Remover Todos"
            icon={<CancelOutlinedIcon />}
            onClick={() => handleSelectAllRecipients(false)}
          />
        )}
      </Box>
      
      {selectedRecipients.length == 0 ? (
        <Box sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '500px',
          color: ColorPalette.textLight,
          backgroundColor: ColorPalette.bgMain,
          borderRadius: '8px'
        }}>
          <Typography variant="body1">
            Nenhum contato selecionado
          </Typography>
        </Box>
      ) : (
        <Box sx={{
          flexGrow: 1,
          overflow: 'auto',
          height: '500px',
          borderRadius: '8px',
          backgroundColor: ColorPalette.white,
          border: `1px solid rgba(237, 54, 128, 0.1)`
        }}>
          <table style={{
            width: '100%',
            borderCollapse: 'separate',
            borderSpacing: '0 8px'
          }}>
            <thead>
              <tr>
                <th style={{
                  color: ColorPalette.textMedium,
                  fontWeight: 500,
                  textAlign: 'left',
                  padding: '8px 16px',
                  borderBottom: `1px solid ${ColorPalette.border}`
                }}>
                  Nome
                </th>
                <th style={{
                  color: ColorPalette.textMedium,
                  fontWeight: 500,
                  textAlign: 'left',
                  padding: '8px 16px',
                  borderBottom: `1px solid ${ColorPalette.border}`,
                  width: '120px'
                }}>
                  Telefone
                </th>
                <th style={{
                  color: ColorPalette.textMedium,
                  fontWeight: 500,
                  textAlign: 'left',
                  padding: '8px 16px',
                  borderBottom: `1px solid ${ColorPalette.border}`,
                  width: '140px'
                }}>
                  Email
                </th>
                <th style={{
                  color: ColorPalette.textMedium,
                  fontWeight: 500,
                  textAlign: 'center',
                  padding: '8px 16px',
                  borderBottom: `1px solid ${ColorPalette.border}`,
                  width: '80px'
                }}>
                  Ação
                </th>
              </tr>
            </thead>
            <tbody>
              {recipients
                .filter(r => selectedRecipients.includes(r.id))
                .map((recipient, index) => (
                  <tr
                    key={recipient.id}
                    style={{
                      backgroundColor: index % 2 == 0 ? ColorPalette.white : "rgba(237, 54, 128, 0.05)",
                    }}
                  >
                    <td style={{
                      padding: '12px 16px',
                      borderTopLeftRadius: '8px',
                      borderBottomLeftRadius: '8px'
                    }}>
                      <Typography variant="body1" sx={{ fontWeight: 500, color: ColorPalette.textDark }}>
                        {recipient.name}
                      </Typography>
                    </td>
                    <td style={{ padding: '12px 16px' }}>
                      <Typography variant="body2" sx={{ color: ColorPalette.textMedium }}>
                        {recipient.phone}
                      </Typography>
                    </td>
                    <td style={{ padding: '12px 16px' }}>
                      <Typography variant="body2" sx={{ color: ColorPalette.textMedium }}>
                        {recipient.email || '-'}
                      </Typography>
                    </td>
                    <td style={{
                      padding: '12px 16px',
                      textAlign: 'center',
                      borderTopRightRadius: '8px',
                      borderBottomRightRadius: '8px'
                    }}>
                      <CustomButton
                        style="error"
                        icon={<CancelOutlinedIcon fontSize="small" />}
                        onClick={() => handleRecipientSelectionChange(recipient.id, false)}
                        rounded={true}
                        outlined={true}
                        title="Remover"
                      />
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </Box>
      )}
    </Paper>
  );
};

export default SelectedRecipientsTable;